import PageVendor from "../../../../../component/page/vendor/PageVendor";
import AccountLayout from "../../../../../component/account/layout/structure/AccountLayout";
import AccountTertiaryNav from "../../../../../component/account/layout/structure/AccountTertiaryNav";
import VendorNav from "../../../../../logic/navigation/vendorNav";
import SalesLayout from "../../chart/component/salesLayout/SalesLayout";
import {ThemeProvider} from "../../../../../../branding/context/ThemeProvider";
import {sbTheme} from "../../../../../../branding/sbTheme";

const breadcrumbTrail = [VendorNav.items.home, VendorNav.items.dashboard, {...VendorNav.items.productSales, selected: true}]

const PageSalesDashboard = () => {

    return (
        <PageVendor>
            <ThemeProvider theme={sbTheme}>
                <AccountLayout breadcrumbTrail={breadcrumbTrail}>
                    <AccountTertiaryNav navList={VendorNav.items.dashboard.children} />
                    <SalesLayout />
                </AccountLayout>
            </ThemeProvider>
        </PageVendor>
    )

}

export default PageSalesDashboard;
